module.exports = __webpack_public_path__ + "static/media/illinois-line-teal.7b714cb6.gif";